export function testSelectors(state) {
  return state.test;
}